import Pin from './Pin'

export default Pin
// eslint-disable-next-line import/export
export * from './Pin'
